import React from 'react';
import '../ServicePage.css'

const ServiceContent = ({ service }) => {
  return (
    <div className="service-content-container">
      <h2>{service.title}</h2>
      <p>{service.description}</p>
      <h3>Key Features</h3>
      <ul>
        {service.keyFeatures.map((feature, index) => (
          <li key={index}>{feature}</li>
        ))}
      </ul>
      <p>{service.moreInfo}</p>
    </div>
  );
};

export default ServiceContent;
